module.exports = __webpack_public_path__ + "school/img/ceshiti.5b84390f.jpg";